module.exports = __webpack_public_path__ + "static/media/pupoli.fec3d094.svg";